import { post, get } from './http'
import qs from 'qs'

// 登录功能
export const login = data => post(`/auth/login?${qs.stringify(data)}`)

// 用户基本信息
export const userInfo = data => post('/v1/getUserInfo', data)

// 更新密码
export const changePassword = data => post(`/v1/changePassword?${qs.stringify(data)}`)

// 登出
export const logout = () => post(`/auth/logout`)

// 获取钉钉KEY
export const dingAppKey = () => get(`/auth/dingAppKey`)

// 获取用户权限标识
export const getUserPermissions = () => get('/v1/user/permissions')

// 获取工时角色ID（用于非临床项目工作类型过滤）
export const getWorkTimeRoleId = () => get('/v1/getWorkTimeRoleId')
